// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"4eb73e91","342":"d9d16e6f"}[chunkId] + ".chunk.js";
};